<template>
  <v-card flat>
    <v-data-table
      :headers="linkedConstructTableHeaders"
      :items="constructDetails"
      :search="constructQuery"
      dense
      class="table-background"
    >
      <template v-slot:top>
        <v-toolbar flat color="#eee">
          <v-text-field
            v-model="constructQuery"
            append-icon="mdi-magnify"
            label="Search for a construct..."
            placeholder="Judging"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary">Add Linked Construct(s)*</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.construct_type_id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.parent_construct_id }}</td>
          <td>{{ props.item.item_association_type_id }}</td>
          <td>{{ props.item.is_observable }}</td>
          <td>{{ formatDate(props.item.created_at) }}</td>
          <td>{{ formatDate(props.item.updated_at) }}</td>
          <td>
            <v-icon
              small
              class="ml-3"
              @click="$goConstructProfile(props.item.id)"
            >
              mdi-pencil
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: ['itemDetails'],
  data () {
    return {
      constructQuery: '',
      constructDetails: [],
      linkedConstructTableHeaders: [
        {
          text: 'Construct Type Id',
          value: 'construct_type_id',
          sortable: true
        },
        { text: 'Name', value: 'name', sortable: true },
        {
          text: 'Parent Construct Id',
          value: 'parent_construct_id',
          sortable: true
        },
        {
          text: 'Item Association Type Id',
          value: 'item_association_type_id',
          sortable: true
        },
        { text: 'Observable', value: 'is_observable', sortable: true },
        { text: 'Date Created', value: 'created_at', sortable: true },
        { text: 'Last Updated', value: 'updated_at', sortable: true },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.getConstructDetails()
    },
    getConstructDetails () {
      const constructMapping = this.itemDetails.construct_task_item_mapping
      this.constructDetails = constructMapping.map(
        (construct) => {
          const constructDetails = construct.construct
          constructDetails.item_association_type_id = construct.item_association_type_id
          return constructDetails
        }
      )
    },
    formatDate (dateString) {
      var options = { year: 'numeric', month: 'long', day: 'numeric' }
      const parsedDate = new Date(dateString)
      return parsedDate.toLocaleString('en-US', options)
    }
  }
}
</script>

<style scoped>
.table-background {
  background-color: #eee;
}
</style>
